var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AddRolesToUser, ModalUiProps } from "../../constanst/adminUsersDTO";
import { DragDropAssignmentAFY, ModalAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React, { useState } from "react";
export var EditAddRoles = function (props) {
    var _a = useState(props.userId), currentUser = _a[0], setCurrentUser = _a[1];
    var _b = useState([]), currentRoles = _b[0], setCurrentRoles = _b[1];
    return (_jsx(ModalAFY, __assign({}, ModalUiProps, { title: "Asignación de rol: ", name: props.userName, openModal: props.openModalEditRoles, showButtons: true, onClose: function () {
            props.setOpenModalEditRoles(false);
        }, onSave: function () { var _a; return (_a = props.handleAssignRoles) === null || _a === void 0 ? void 0 : _a.call(props, currentUser, currentRoles); } }, { children: _jsx(DragDropAssignmentAFY, __assign({}, AddRolesToUser, { userId: props.userId, assignedItems: props.assignedRoles, availableItems: props.rolesList, onAssignmentChange: function (user, roles) {
                setCurrentUser(user);
                setCurrentRoles(roles);
            } })) })));
};
